import React from 'react';
import '../styles/global.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-left">
          <p>© 2018 - {new Date().getFullYear()} JUDr. Karol Plank - Advokátska kancelária</p>
        </div>

        <div className="footer-right">
          <h3>Kontakt</h3>
          <p>Tel: <a href="tel:+421917289492">+421 0905 135 422</a></p>
          <p>Email: <a href="mailto:karolplank@gmail.com">karolplank@gmail.com</a></p>
          <address>
            JUDr. Karol Plank, advokát<br/>
            Štúrova 13, 810 00 Bratislava<br/>
            IČO: 51 289 610 | DIČ: 2120680529<br/>
            Register:  OR MS BA III odd. Sro vl. č. 124956/B 
          </address>
        </div>
      </div>
    </footer>
  );
}
